// Import necessary dependencies
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Get the root element from index.html
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Render the App component
// StrictMode helps identify potential problems
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Measure performance
reportWebVitals();
